export enum RoleType {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_TECHNICIAN = 'ROLE_TECHNICIAN',
  ROLE_PRL_TECHNICIAN = 'ROLE_PRL_TECHNICIAN',
  ROLE_OPERATING_SUPERVISOR = 'ROLE_OPERATING_SUPERVISOR',
  ROLE_PROJECT_MANAGER = 'ROLE_PROJECT_MANAGER',
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_OPERATING_MANAGER = 'ROLE_OPERATING_MANAGER',
}
